export default {
  sihuaLu: '禄',
  sihuaQuan: '权',
  sihuaKe: '科',
  sihuaJi: '忌',
} as const;
